import SEO from "@/common/components/seo";
import { Button } from "@/components/ui/button";
import React from "react";
import { Link } from "react-router-dom";

const NotFound: React.FC = () => (
	<div className="flex h-screen flex-col items-center justify-center bg-white text-center">
		<SEO
			title="404 - Page Not Found"
			description="The page you are looking for does not exist."
		/>
		<h1 className="mb-4 text-6xl font-extrabold text-blue-700">404</h1>
		<p className="mb-8 text-2xl font-semibold text-gray-700">Page Not Found</p>
		<Link to="/">
			<Button variant="default" className="px-8 py-3 text-lg font-bold">
				Go Home
			</Button>
		</Link>
	</div>
);

export default NotFound;
